import React from 'react'
import cn from 'classnames'
import Cookies from 'js-cookie'
import Banner from '@mc/banner'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { MAW_I18N_NAMESPACE } from '../../i18n/i18nInstance'
import { PROGRAMS_ANNOUNCEMENT_COOKIE_BANNER } from '../constants'
import classes from './ProgramsBanner.module.scss'

export const ProgramsBanner = () => {
  const { t } = useTranslation(MAW_I18N_NAMESPACE)

  const existingDisplayCount = Cookies.get(PROGRAMS_ANNOUNCEMENT_COOKIE_BANNER)
  const show = !existingDisplayCount || parseInt(existingDisplayCount, 10) < 3

  const onClose = () => {
    const displayCount = existingDisplayCount
      ? parseInt(existingDisplayCount, 10) + 1
      : 1
    Cookies.set(PROGRAMS_ANNOUNCEMENT_COOKIE_BANNER, String(displayCount))
  }

  if (!show) return null

  return (
    <Banner
      theme='light'
      isClosable
      closeBtnClassName={classes.closeButton}
      className='mc-py-4'
      onClose={onClose}
    >
      <div className='container-fluid d-flex align-items-center mc-mr-8'>
        <span className='mc-sr-only'>{t('newFeatureAriaLabel')}</span>

        <div
          className={cn(classes.announcement, 'mc-text-h2 mc-mr-3 d-flex')}
          aria-hidden
        >
          <span className='mc-mr-1'>{t('new')}</span>
          <span className='mc-text-color--primary'>{t('feature')}</span>
        </div>

        <p className='flex-1'>{t('description')}</p>
        <Button as='a' href='/homepage/programs' kind='tertiary' size='sm'>
          {t('cta')}
        </Button>
      </div>
    </Banner>
  )
}
